import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'

import { useModule } from '@/hooks/useModule'
import { Modal } from '@/types/modal'
import { MODULE_TYPE } from '@/types/module'

export interface ModalContextProps {
  modal: Modal | null
  openModal: (modalId: string) => void
  checkBoxModal: {
    opened: boolean
    url?: string
  }
  setCheckBoxModal: Dispatch<
    SetStateAction<{
      opened: boolean
      url?: string | undefined
    }>
  >
  closeModal: () => void
}

export const ModalContext = createContext({} as ModalContextProps)

interface ModalProviderProps {
  children: ReactNode
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const { currentModule } = useModule()
  const [modal, setModal] = useState<ModalContextProps['modal']>(null)
  const [checkBoxModal, setCheckBoxModal] = useState<ModalContextProps['checkBoxModal']>({
    opened: false
  })

  const closeModal = () => setModal(null)
  const openModal = (modalId: string) => {
    if (currentModule?.type !== MODULE_TYPE.DEFAULT) return

    if (!currentModule?.modals) throw new Error('No modals found in current module')
    setModal(currentModule.modals[modalId])
  }

  const value = {
    modal,
    openModal,
    closeModal,
    checkBoxModal,
    setCheckBoxModal
  }

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}
